/* eslint-disable max-lines */
/* eslint-disable max-lines-per-function */
/* eslint-disable complexity */
/* eslint-disable id-length */
import React from 'react';
import {
  Cross2Icon,
  InfoCircledIcon,
  ExclamationTriangleIcon,
  ChevronDownIcon,
  ChevronUpIcon,
  ChevronLeftIcon,
  ChevronRightIcon,
  UpdateIcon,
  PaperPlaneIcon,
  ArrowLeftIcon,
  ArrowRightIcon,
  DesktopIcon,
  PlusCircledIcon,
  MinusCircledIcon,
  TimerIcon,
  PauseIcon,
  PersonIcon,
  PlayIcon,
  DragHandleDots2Icon,
  CheckIcon,
  DotsHorizontalIcon,
  DotFilledIcon,
  DownloadIcon,
  Link1Icon,
  ExternalLinkIcon,
  CalendarIcon,
} from '@radix-ui/react-icons';
import { useTranslation } from 'react-i18next';
import {
  Translate,
  SmileyFaceCard,
  ErrorChart,
  ErrorCard,
  Calendar,
  NextDoor,
  Facebook,
  Twitter,
  LinkedIn,
  Mail,
  Share,
  CommunicationPreferences,
  MagnifyGlass,
  QrCode,
  Instagram,
  YouTube,
  WhatsApp,
  BlueSky,
  SearchGlass,
  ArrowRightThinIcon,
  ArrowLeftThinIcon,
  HeartEmpty,
  HeartFilled,
} from './IconRaw';

export type IconName =
  | 'close'
  | 'info'
  | 'warning'
  | 'chevron-down'
  | 'chevron-up'
  | 'chevron-left'
  | 'chevron-right'
  | 'drag-dots'
  | 'heart-empty'
  | 'heart-filled'
  | 'update'
  | 'translate'
  | 'smileyFaceCard'
  | 'errorChart'
  | 'errorCard'
  | 'calendar'
  | 'nextdoor'
  | 'facebook'
  | 'twitter'
  | 'linkedin'
  | 'whatsapp'
  | 'blueSky'
  | 'mail'
  | 'share'
  | 'communicationPreferences'
  | 'paperPlane'
  | 'arrow-left'
  | 'arrow-left-thin'
  | 'arrow-right'
  | 'arrow-right-thin'
  | 'desktop'
  | 'plus-circle'
  | 'minus-circle'
  | 'timer'
  | 'person'
  | 'play'
  | 'pause'
  | 'magnifyGlass'
  | 'qrCode'
  | 'instagram'
  | 'youtube'
  | 'check'
  | 'dots-horizontal'
  | 'dot-filled'
  | 'download-arrow'
  | 'link'
  | 'searchGlass'
  | 'external-link'
  | 'date';

interface IconProps {
  name: IconName;
  classname?: string;
  color?: string;
  height?: number;
  width?: number;
  ariaLabel?: string;
  ariaHidden?: boolean;
}
export function Icon(props: IconProps): JSX.Element | null {
  const { name, classname, color, height = 20, width = 20, ariaLabel, ariaHidden } = props;
  const { t } = useTranslation();
  const label = ariaLabel || t(`icons.${name}`);

  switch (name) {
    case 'close':
      return (
        <Cross2Icon
          height={height}
          width={width}
          color={color}
          className={classname}
          role="img"
          aria-label={label}
          aria-hidden={ariaHidden}
        />
      );
    case 'info':
      return (
        <InfoCircledIcon
          height={height}
          width={width}
          color={color}
          className={classname}
          role="img"
          aria-label={label}
          aria-hidden={ariaHidden}
        />
      );
    case 'warning':
      return (
        <ExclamationTriangleIcon
          height={height}
          width={width}
          color={color}
          className={classname}
          role="img"
          aria-label={label}
          aria-hidden={ariaHidden}
        />
      );
    case 'chevron-down':
      return (
        <ChevronDownIcon
          height={height}
          width={width}
          color={color}
          className={classname}
          role="img"
          aria-label={label}
          aria-hidden={ariaHidden}
        />
      );
    case 'chevron-up':
      return (
        <ChevronUpIcon
          height={height}
          width={width}
          color={color}
          className={classname}
          role="img"
          aria-label={label}
          aria-hidden={ariaHidden}
        />
      );
    case 'chevron-left':
      return (
        <ChevronLeftIcon
          height={height}
          width={width}
          color={color}
          className={classname}
          role="img"
          aria-label={label}
          aria-hidden={ariaHidden}
        />
      );
    case 'chevron-right':
      return (
        <ChevronRightIcon
          height={height}
          width={width}
          color={color}
          className={classname}
          role="img"
          aria-label={label}
          aria-hidden={ariaHidden}
        />
      );
    case 'heart-empty':
      return <HeartEmpty classname={classname} ariaLabel={label} ariaHidden={ariaHidden} />;
    case 'heart-filled':
      return <HeartFilled classname={classname} ariaLabel={label} ariaHidden={ariaHidden} />;
    case 'drag-dots':
      return (
        <DragHandleDots2Icon
          height={height}
          width={width}
          color={color}
          className={classname}
          role="img"
          aria-label={label}
          aria-hidden={ariaHidden}
        />
      );
    case 'update':
      return (
        <UpdateIcon
          height={height}
          width={width}
          color={color}
          className={classname}
          role="img"
          aria-label={label}
          aria-hidden={ariaHidden}
        />
      );
    case 'check':
      return (
        <CheckIcon
          height={height}
          width={width}
          color={color}
          className={classname}
          role="img"
          aria-label={label}
          aria-hidden={ariaHidden}
        />
      );
    case 'dots-horizontal':
      return (
        <DotsHorizontalIcon
          height={height}
          width={width}
          color={color}
          className={classname}
          role="img"
          aria-label={label}
          aria-hidden={ariaHidden}
        />
      );
    case 'dot-filled':
      return (
        <DotFilledIcon
          height={height}
          width={width}
          color={color}
          className={classname}
          role="img"
          aria-label={label}
          aria-hidden={ariaHidden}
        />
      );
    case 'link':
      return (
        <Link1Icon
          height={height}
          width={width}
          color={color}
          className={classname}
          role="img"
          aria-label={label}
          aria-hidden={ariaHidden}
        />
      );
    case 'external-link':
      return (
        <ExternalLinkIcon
          height={height}
          width={width}
          color={color}
          className={classname}
          role="img"
          aria-label={label}
          aria-hidden={ariaHidden}
        />
      );
    case 'translate':
      return <Translate height={height} width={width} ariaLabel={label} ariaHidden={ariaHidden} />;
    case 'smileyFaceCard':
      return <SmileyFaceCard classname={classname} ariaLabel={label} ariaHidden={ariaHidden} />;
    case 'errorChart':
      return <ErrorChart classname={classname} ariaLabel={label} ariaHidden={ariaHidden} />;
    case 'errorCard':
      return <ErrorCard classname={classname} ariaLabel={label} ariaHidden={ariaHidden} />;
    case 'calendar':
      return <Calendar classname={classname} ariaLabel={label} ariaHidden={ariaHidden} />;
    case 'nextdoor':
      return <NextDoor classname={classname} ariaLabel={label} ariaHidden={ariaHidden} />;
    case 'facebook':
      return <Facebook classname={classname} ariaLabel={label} ariaHidden={ariaHidden} />;
    case 'twitter':
      return <Twitter classname={classname} ariaLabel={label} ariaHidden={ariaHidden} />;
    case 'linkedin':
      return <LinkedIn classname={classname} ariaLabel={label} ariaHidden={ariaHidden} />;
    case 'whatsapp':
      return <WhatsApp classname={classname} ariaLabel={label} ariaHidden={ariaHidden} />;
    case 'blueSky':
      return <BlueSky classname={classname} ariaLabel={label} ariaHidden={ariaHidden} />;
    case 'mail':
      return <Mail classname={classname} ariaLabel={label} ariaHidden={ariaHidden} />;
    case 'share':
      return <Share classname={classname} fillColor={color} ariaLabel={label} ariaHidden={ariaHidden} />;
    case 'communicationPreferences':
      return <CommunicationPreferences classname={classname} ariaLabel={label} ariaHidden={ariaHidden} />;
    case 'date':
      return (
        <CalendarIcon
          height={height}
          width={width}
          color={color}
          className={classname}
          role="img"
          aria-label={label}
          aria-hidden={ariaHidden}
        />
      );
    case 'paperPlane':
      return (
        <PaperPlaneIcon
          height={height}
          width={width}
          color={color}
          className={classname}
          role="img"
          aria-label={label}
          aria-hidden={ariaHidden}
        />
      );
    case 'arrow-left':
      return (
        <ArrowLeftIcon
          height={height}
          width={width}
          color={color}
          className={classname}
          role="img"
          aria-label={label}
          aria-hidden={ariaHidden}
        />
      );
    case 'arrow-right':
      return (
        <ArrowRightIcon
          height={height}
          width={width}
          color={color}
          className={classname}
          role="img"
          aria-label={label}
          aria-hidden={ariaHidden}
        />
      );
    case 'arrow-right-thin':
      return (
        <ArrowRightThinIcon
          height={height}
          width={width}
          classname={classname}
          ariaLabel={label}
          ariaHidden={ariaHidden}
        />
      );
    case 'arrow-left-thin':
      return (
        <ArrowLeftThinIcon
          height={height}
          width={width}
          classname={classname}
          ariaLabel={label}
          ariaHidden={ariaHidden}
        />
      );
    case 'desktop':
      return (
        <DesktopIcon
          height={height}
          width={width}
          color={color}
          className={classname}
          role="img"
          aria-label={label}
          aria-hidden={ariaHidden}
        />
      );
    case 'plus-circle':
      return (
        <PlusCircledIcon
          height={height}
          width={width}
          color={color}
          className={classname}
          role="img"
          aria-label={label}
          aria-hidden={ariaHidden}
        />
      );
    case 'minus-circle':
      return (
        <MinusCircledIcon
          height={height}
          width={width}
          color={color}
          className={classname}
          role="img"
          aria-label={label}
          aria-hidden={ariaHidden}
        />
      );
    case 'timer':
      return (
        <TimerIcon
          height={height}
          width={width}
          color={color}
          className={classname}
          role="img"
          aria-label={label}
          aria-hidden={ariaHidden}
        />
      );
    case 'person':
      return (
        <PersonIcon
          height={height}
          width={width}
          color={color}
          className={classname}
          role="img"
          aria-label={label}
          aria-hidden={ariaHidden}
        />
      );
    case 'play':
      return (
        <PlayIcon
          height={height}
          width={width}
          color={color}
          className={classname}
          role="img"
          aria-label={label}
          aria-hidden={ariaHidden}
        />
      );
    case 'pause':
      return (
        <PauseIcon
          height={height}
          width={width}
          color={color}
          className={classname}
          role="img"
          aria-label={label}
          aria-hidden={ariaHidden}
        />
      );
    case 'magnifyGlass':
      return (
        <MagnifyGlass height={height} width={width} classname={classname} ariaLabel={label} ariaHidden={ariaHidden} />
      );
    case 'qrCode':
      return <QrCode height={height} width={width} classname={classname} ariaLabel={label} ariaHidden={ariaHidden} />;
    case 'instagram':
      return <Instagram classname={classname} ariaLabel={label} ariaHidden={ariaHidden} />;
    case 'youtube':
      return <YouTube classname={classname} ariaLabel={label} ariaHidden={ariaHidden} />;
    case 'download-arrow':
      return (
        <DownloadIcon
          height={height}
          width={width}
          color={color}
          className={classname}
          role="img"
          aria-label={label}
          aria-hidden={ariaHidden}
        />
      );
    case 'searchGlass':
      return <SearchGlass classname={classname} ariaLabel={label} ariaHidden={ariaHidden} />;
    default:
      return null;
  }
}
